'use strict';

var React = require('react');

var SvgBulletIcon = function SvgBulletIcon(props) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    viewBox: "0 0 20 20"
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M12 10c0 1.105-.895 2-2 2s-2-.895-2-2 .895-2 2-2 2 .895 2 2Z"
  }));
};
SvgBulletIcon.displayName = "BulletIcon";

exports.SvgBulletIcon = SvgBulletIcon;
